import React from 'react';

const Footer = () => (
  <footer className="app-footer">
    <span className="d-inline-block">Phool Mali &copy; 2018</span>
  </footer>
);
export default Footer;
